import useSelector from '@app/hooks/useSelector';

import type { ProjectType } from '../../../../types/project';
import { getCustomTranslationStatusesAvailable } from '../../reducers/downloadData/selectors';
import type { FileFormat } from '../../types';
import FilterData from './FilterData';
import type { Value } from './types';

interface FilterDataContainerProps {
    value: Value;
    fileFormat: FileFormat;
    projectType: ProjectType;
    switchIncludeAll: boolean;
    projectId: string;
    onChange: (value: Value) => void;
}

const FilterDataContainer = (props: FilterDataContainerProps) => {
    const customTranslationStatusesAvailable = useSelector(getCustomTranslationStatusesAvailable);

    return (
        <section aria-label="Content to export">
            <FilterData {...props} isCustomTranslationStatusesAvailable={customTranslationStatusesAvailable} />
        </section>
    );
};

export default FilterDataContainer;
